import React from 'react';
import '../less/index';
import FilesForDownloadNew from "../../../auxiliary-components/shared/FilesForDownloadNew";

export default function template() {

    return (
        <div className='module-downloads-page'>
            <FilesForDownloadNew
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              loader={this.state.loader}
            />
        </div>
    );
}
